import React from 'react';
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis, } from 'recharts';
import { green } from '@mui/material/colors';
import { useTranslation } from 'react-i18next';
var RemainingWarehouseItemsChart = function (_a) {
    var data = _a.data;
    var t = useTranslation().t;
    var translate = React.useCallback(function (key) {
        return t("pages.dashboard.remainingWarehouseItems.".concat(key));
    }, [t]);
    var yAxisMax = React.useMemo(function () {
        var max = data.reduce(function (result, current) {
            var v = parseFloat(current.value);
            return result > v ? result : v;
        }, 0);
        return max + (100 - (max % 100));
    }, [data]);
    return (React.createElement(ResponsiveContainer, { width: "100%", height: 200 },
        React.createElement(BarChart, { data: data, margin: {
                top: 30,
            } },
            React.createElement(XAxis, { dataKey: "label" }),
            React.createElement(YAxis, { domain: [0, yAxisMax], label: {
                    value: translate('unitLabel'),
                    position: 'top',
                    offset: 15,
                } }),
            React.createElement(Tooltip, null),
            React.createElement(Bar, { dataKey: "value", fill: green[500], name: translate('unitLabel') }))));
};
export default RemainingWarehouseItemsChart;
